module.exports = "<gz-spinner></gz-spinner>";


//////////////////
// WEBPACK FOOTER
// ./components/redirect/redirect.jade
// module id = 268
// module chunks = 0